// extracted by mini-css-extract-plugin
export default {"nav":"UnauthorizedMenu_nav__Yrg5K","item":"UnauthorizedMenu_item__BWAP2"};